import { restClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'

const q = (p: Record<string, unknown>) => new URLSearchParams(
  Object.entries(p).filter(([, v]) => v !== undefined && v !== null && v !== '').reduce((a, [k, v]) => ({ ...a, [k]: String(v) }), {})
).toString()

export const commissionService = {
  // School / vendor commission list (also used for "certificate-drivys" view)
  vendorList: (p: { page?: number; limit?: number; search?: string } = {}) => {
    const params: Record<string, unknown> = { page: p.page ?? 1, limit: p.limit ?? 15 }
    if (p.search) params.search = p.search
    return restClient.get(`${endpoints.commission.listAdmin}?${q(params)}`).then(r => r.data)
  },
  // Per-trainer commission list (also used for "certificate-trainer" view)
  trainerList: (p: { page?: number; limit?: number; search?: string; vendor_id?: number } = {}) => {
    const params: Record<string, unknown> = { page: p.page ?? 1, limit: p.limit ?? 15, locale: 'en' }
    if (p.search) params.search = p.search
    if (p.vendor_id) params.vendor_id = p.vendor_id
    return restClient.get(`${endpoints.commission.trainerCommission}?${q(params)}`).then(r => r.data)
  },
  update: (d: Record<string, unknown>) =>
    restClient.post(endpoints.commission.updateCommission, d).then(r => r.data),
}
